import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const INPUT = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.extra.space.SurveyConfiguration.Input,
    graphql.schema.SpaceSurveyConfigurationInput
  >({
    functionalUsage: graphql.transformers.IN.object<
      ents.extra.space.SurveyConfiguration.FunctionalUsage,
      graphql.schema.SpaceSurveyConfigurationFunctionalUsageInput
    >({
      requireFunctionalUsageAssignmentsForSelectedAccounts:
        graphql.transformers.IN.nonNull(transformers.PASS_THROUGH),
      requireSponsoredAccountAssignmentsForSponsoredFunctionalUsages:
        graphql.transformers.IN.nonNull(transformers.PASS_THROUGH),
    }),
    id: transformers.PASS_THROUGH,
    tools: graphql.transformers.IN.nonNull(
      graphql.transformers.IN.object({
        allowUsersToUnlockRoomsDirectly: graphql.transformers.IN.nonNull(
          transformers.PASS_THROUGH,
        ),
      }),
    ),
  }),
)
